import React, { Component } from "react";

import AdminLink from "../app/AdminLink";

export default class OrderList extends Component {
  render() {
    return (
      <div className="sales">
        <AdminLink />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sales/OrderList.js